module.exports = __webpack_public_path__ + "am.no1.890cd6d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/am.no1.jpg
// module id = X8pL
// module chunks = 0